import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Modal from "../../components/Modal";
import { CONTACT_US_EMAIL, ERROR_MESSAGE } from "../../constants";
import useUserStore from "../../store/User.store";
import Button from "../Button";

import "./noMatchCard.scss";

const NoMatchCard = ({ title, subtitle, description }) => {
  const user = useUserStore((state) => state.data.user);
  const handleSignOut = useUserStore((state) => state.actions.handleSignOut);
  const navigate = useNavigate();

  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleSignOutUser = async () => {
    const res = await handleSignOut(user.username);

    // Redirect to Sign In if successful
    if (res.responseCode === 200) {
      useUserStore.persist.clearStorage();

      // remove user session proposals
      sessionStorage.removeItem("user-session-proposals");

      navigate("/signin");
    } else {
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <div className="nomatchcard">
        <div className="nomatchcard__content">
          <div className="nomatchcard__content-text">
            <h1>{title}</h1>
            <h2>{subtitle}</h2>
            <p>{description}</p>
          </div>
          <div className="nomatchcard__action">
            {subtitle === "Unauthorized Access" ? (
              <Button
                variant="outline"
                iconName="logout"
                onClick={handleSignOutUser}
              >
                Sign Out
              </Button>
            ) : (
              <Button href="/proposals" variant="primary" size="medium">
                Go to All Proposals Page
              </Button>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        onConfirm={null}
        heading="Error Signing Out"
        subtitle={ERROR_MESSAGE.SUBTITLE.TRY_AGAIN}
        cancelButton={{
          variant: "outline",
          children: "Retry Signout",
        }}
      />
    </>
  );
};

NoMatchCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.node,
};

NoMatchCard.defaultProps = {
  title: ERROR_MESSAGE.TITLE,
  subtitle: ERROR_MESSAGE.SUBTITLE.NOT_FOUND,
  description: (
    <>
      If the error persists, please contact us:{" "}
      <Button
        variant="link"
        size="small"
        href={`mailto:${CONTACT_US_EMAIL}`}
        aria-label={`Contact us at ${CONTACT_US_EMAIL}.`}
      >
        {CONTACT_US_EMAIL}
      </Button>
    </>
  ),
};

export default NoMatchCard;
